const React = require('react');
const FormAuthBase = require('./components/Base/B');
const ButtonAccept = require('../../../dumb/Button/Accept');


module.exports = (props) => {
  return (
    <FormAuthBase>
      <div
        className="f20 fw5 tc"
      >Reset security verification</div>
      <div className="f15 fw4 tl c0 mt50 mh-110">
        <span className="fwB">
          I lost my Google 2FA reset code, how can I get it back?
        </span>
        <br/><br/>

        I can access a device that was set up with the Google 2FA reset code.
        <br/><br/>

        We suggest you disable Google Authenticator on your Lunu account first,
        then enable it again using your new device. Remember to save your
        reset code this time.
        <br/><br/>

        <span className="fwB">
          I can&apos;t access a device that was set up with the Google 2FA
          reset code
        </span>
        <br/><br/>

        Please confirm request to our Support to get a new code.
      </div>
      <div className="layoutLow fhaC fvaC mt90">
        <ButtonAccept
          className="w"
          href="mailto:support@lunu.io"
        >Confirm request</ButtonAccept>
      </div>
    </FormAuthBase>
  );
};
